import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "sanitize.css/sanitize.css";

import LanguageProvider from "./containers/LanguageProvider";

import { store } from "./storeExporter";
import IntlGlobalProvider from "./IntlGlobalProvider";
import { translationMessages } from "./i18n";
import App from "./App";
import history from "./history";
import "bootstrap/dist/css/bootstrap.css";
import { ConnectedRouter } from "connected-react-router";

import ErrorBoundary from "./containers/ErrorBoundary/ErrorBoundary";

const MOUNT_NODE = document.getElementById("root");

ReactDOM.render(
  <Provider store={store}>
    <LanguageProvider messages={translationMessages}>
      <IntlGlobalProvider>
        <ConnectedRouter history={history}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </ConnectedRouter>
      </IntlGlobalProvider>
    </LanguageProvider>
  </Provider>,
  MOUNT_NODE
);
